/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestManagerNotificationActionData
 */
export interface RequestManagerNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof RequestManagerNotificationActionData
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof RequestManagerNotificationActionData
     */
    granteeUserId: string;
    /**
     * 
     * @type {string}
     * @memberof RequestManagerNotificationActionData
     */
    granteeAddress: string;
}

/**
 * Check if a given object implements the RequestManagerNotificationActionData interface.
 */
export function instanceOfRequestManagerNotificationActionData(value: object): value is RequestManagerNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "userId" in value && value["userId"] !== undefined;
    isInstance = isInstance && "granteeUserId" in value && value["granteeUserId"] !== undefined;
    isInstance = isInstance && "granteeAddress" in value && value["granteeAddress"] !== undefined;

    return isInstance;
}

export function RequestManagerNotificationActionDataFromJSON(json: any): RequestManagerNotificationActionData {
    return RequestManagerNotificationActionDataFromJSONTyped(json, false);
}

export function RequestManagerNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestManagerNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'granteeUserId': json['grantee_user_id'],
        'granteeAddress': json['grantee_address'],
    };
}

export function RequestManagerNotificationActionDataToJSON(value?: RequestManagerNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.userId,
        'grantee_user_id': value.granteeUserId,
        'grantee_address': value.granteeAddress,
    };
}

